import graph from './graph';
import React, { useEffect, useState } from 'react';

import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import GppGoodRoundedIcon from '@mui/icons-material/GppGoodRounded';
import DeleteOutlineRounded from '@mui/icons-material/DeleteOutlineRounded';

import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { isEmptyObject } from 'helpers/formatObject';
import { useLazyQuery, useMutation } from '@apollo/client';
import { NewDialog, NewDialogTitle, NewDialogContent, NewDialogActions } from 'components';

import { Card, Stack, Badge, Avatar, Button, CardHeader, Typography, CircularProgress } from '@mui/material';

export default function UserRoles({ ids, title, refetch, roles = [] }) {
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState([]);
  const { userToken } = useSelector((state) => state.auth);

  const [deleteModel] = useMutation(graph.delete.query);
  const [fetchModel, { loading }] = useLazyQuery(graph.get.query);

  const onOpen = () => setOpen(true);
  const onClose = () => setOpen(false);

  const getModel = async () => {
    try {
      const { data } = await fetchModel({
        context: {
          serviceName: graph.get.serviceName,
          headers: {
            authorization: `Bearer ${userToken}`,
          },
        },
        variables: {
          ids,
          for_admin: 1,
        },
      });
      if (!isEmptyObject(data)) {
        const res = data[graph.get.name].data[0];
        const { all_roles } = res;
        if (all_roles) {
          setFormData(all_roles);
        }
      }
    } catch (error) {}
  };

  const onDelete = async (role_id, lab_id) => {
    try {
      const { data, errors } = await deleteModel({
        context: {
          serviceName: graph.delete.serviceName,
          headers: {
            authorization: `Bearer ${userToken}`,
          },
        },
        variables: { user_id: ids, role_id, lab_id },
      });
      if (!errors) {
        refetch();
        onClose();
        if (!isEmptyObject(data)) {
          data[graph.delete.name]?.messages.map((message) => toast.success(String(message)));
        }
      }
    } catch (error) {}
  };

  useEffect(() => {
    open && getModel();
  }, [open]);

  return (
    <>
      <Tooltip title={title}>
        <Badge
          color="error"
          variant="dot"
          overlap="circular"
          invisible={!roles.length}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <IconButton
            size="small"
            color="error"
            onClick={onOpen}
            disabled={!roles.length}
            sx={{ bgcolor: 'action.hover' }}
          >
            <GppGoodRoundedIcon fontSize="small" />
          </IconButton>
        </Badge>
      </Tooltip>
      <NewDialog label="delete" open={open} onClose={onClose}>
        <NewDialogTitle title={title} onClose={onClose} />
        <NewDialogContent isPopup>
          <Stack p={1} flex={2} rowGap={1} bgcolor="background.paper">
            {loading ? (
              <Stack rowGap={2} height="100%" alignItems="center" justifyContent="center">
                <CircularProgress size={20} color="inherit" />
                <Typography align="center" variant="caption" color="text.disabled">
                  در حال بارگذاری...
                </Typography>
              </Stack>
            ) : (
              <Stack rowGap={1}>
                {formData.map((item, i) => {
                  const { role, labs, units } = item;
                  if (units) {
                    return units.map(({ id, title }, i) => (
                      <Card key={i} sx={{ width: '100%' }}>
                        <CardHeader
                          avatar={
                            <Avatar sx={{ bgcolor: 'action.hover' }}>
                              <GppGoodRoundedIcon fontSize="small" color="error" />
                            </Avatar>
                          }
                          title={role.title}
                          subheader={title}
                          action={
                            <IconButton color="error" disabled onClick={() => onDelete(role.id)}>
                              <DeleteOutlineRounded fontSize="small" />
                            </IconButton>
                          }
                        />
                      </Card>
                    ));
                  }
                  if (labs) {
                    return labs
                      .filter((x) => x)
                      .map(({ id, title }, i) => (
                        <Card key={i} sx={{ width: '100%' }}>
                          <CardHeader
                            avatar={
                              <Avatar sx={{ bgcolor: 'action.hover' }}>
                                <GppGoodRoundedIcon fontSize="small" color="error" />
                              </Avatar>
                            }
                            title={role.title}
                            subheader={title}
                            action={
                              <IconButton disabled color="error" onClick={() => onDelete(role.id)}>
                                <DeleteOutlineRounded fontSize="small" />
                              </IconButton>
                            }
                          />
                        </Card>
                      ));
                  }
                  return (
                    <Card key={i} sx={{ width: '100%' }}>
                      <CardHeader
                        avatar={
                          <Avatar sx={{ bgcolor: 'action.hover' }}>
                            <GppGoodRoundedIcon fontSize="small" color="error" />
                          </Avatar>
                        }
                        title={role.title}
                        // subheader={title}
                        action={
                          <IconButton
                            color="error"
                            disabled
                            // onClick={() => onDelete(role.id)}
                          >
                            <DeleteOutlineRounded fontSize="small" />
                          </IconButton>
                        }
                      />
                    </Card>
                  );
                })}
              </Stack>
            )}
          </Stack>
        </NewDialogContent>
      </NewDialog>
    </>
  );
}
